var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-info-item"},[_c('InfoItemTitle',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"ui-info-item_data"},[_c('app-update-rate',{attrs:{"value":_vm.value}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }